// i18n area 'hci' — locale bg-BG (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/hci.bg-BG.meta.json.
import type { enUS } from './hci'

export const bgBG: typeof enUS = {
  hci: {
    ceph: {
      title: 'Ceph клъстери',
      createButton: 'Създай Ceph клъстер',
      emptyTitle: 'Няма управлявани Ceph клъстери',
      emptyBody: 'TVirt разгръща и притежава Ceph върху възлите членове, хиперконвергентно с работното натоварване от ВМ. Създайте клъстер: първият монитор и неговият мениджър се раждат автоматично на избрания възел за управление — после го разширете с още монитори и OSD устройства.',
      pageTitle: 'Ceph клъстери',
      colState: 'Състояние',
      colMembers: 'Членове',
      colSize: 'Размер',
      colVersion: 'Версия на Ceph',
      sizeCell: '{used} GiB заети от общо {total} GiB',
      phase: {
        'not-deployed': 'Неразгърнат',
        deploying: 'Разгръщане',
        healthy: 'В изправност',
        degraded: 'Деградирал',
        error: 'Грешка',
        destroying: 'Унищожаване',
        destroyed: 'Унищожен'
      },
      health: {
        HEALTH_OK: 'В изправност (HEALTH_OK)',
        HEALTH_WARN: 'С предупреждения (HEALTH_WARN)',
        HEALTH_ERR: 'В грешка (HEALTH_ERR)',
        unknown: 'Още не е наблюдавано',
        observedAt: 'наблюдавано {time}'
      },
      create: {
        title: 'Създай Ceph клъстер',
        info: 'При създаването на нов Ceph клъстер се избира първият възел, върху който ще се инсталират ролите MON и MGR. Трябва също да се посочи коя подмрежа носи Ceph трафика: публичната подмрежа служи за общия мрежов трафик, а клъстерната подмрежа — за вътрешните реплики между OSD; не е задължително подмрежите да са различни.',
        controlNode: 'Възел за управление',
        controlNodeHint: 'Възелът член, където се раждат първите MON + MGR.',
        publicSubnet: 'Публична подмрежа',
        publicSubnetHint: 'Подмрежа, регистрирана в IPAM — public_network на Ceph. Неизменяема след създаването.',
        clusterSubnet: 'Клъстерна подмрежа',
        clusterSubnetHint: 'Подмрежа, регистрирана в IPAM — cluster_network на Ceph (реплика/backfill).',
        noSubnets: 'Няма регистрирани подмрежи — създайте ги първо в IPAM',
        sameSubnet: 'Една и съща подмрежа за публичния и клъстерния трафик',
        sameSubnetHint: 'Отметнато = клъстерната мрежа (реплика/backfill) съвпада с публичната. Неотметнато = изберете нейната подмрежа И адреса на възела за управление вътре в нея.',
        controlAddress: 'Адрес на възела за управление',
        controlAddressHint: 'Адрес, който IPAM познава за възела в публичната подмрежа.',
        controlClusterAddress: 'Клъстерен адрес на възела за управление',
        controlClusterAddressHint: 'Адрес, който IPAM познава за възела в клъстерната подмрежа.',
        noAddresses: 'IPAM не познава адреси на този възел в избраната подмрежа',
        started: 'Клъстерът е създаден — бутстрапът продължава като макрозадача; фазата се обновява сама',
        error: 'Клъстерът беше отказан'
      },
      detail: {
        actions: 'Налични действия',
        tabOverview: 'Преглед',
        tabManagementNodes: 'MON и MGR',
        tabDisks: 'OSD',
        tabPools: 'Пулове',
        tabObjects: 'Обекти',
        tabCrush: 'CRUSH карта',
        tabCephfs: 'CephFS',
        tabAdvanced: 'Разширени',
        phase: 'Фаза',
        checksTitle: 'Активни проверки на здравето',
        noChecks: 'Няма активни проверки на здравето',
        checkMuted: 'заглушена',
        summaryPools: 'Пулове',
        summaryFilesystems: 'Файлови системи',
        nodesCard: 'Възли',
        monHint: 'По един MGR върви колокиран с всеки MON. Три MON са препоръчаният кворум; лабораторен клъстер тръгва с един. OSD и MDS живеят в своите раздели.',
        monHintSplit: 'MON и MGR са разделени на този клъстер (Разширени): всяка роля е собствено членство по възел. Три MON са препоръчаният кворум; поне един MGR трябва да съществува.',
        noMons: 'Няма декларирани монитори',
        addNode: 'Добави възел',
        removeNode: 'Премахни възел',
        removeNodeFrom: 'Премахни възела {node} (неговия MON и колокирания MGR)',
        roleMon: 'Роля MON',
        roleMgr: 'Роля MGR',
        roleNa: 'Н/П',
        roleNotObserved: 'още не е наблюдавана',
        monInQuorum: 'в кворума',
        monOutQuorum: 'извън кворума',
        mgrActive: 'активен',
        mgrStandby: 'standby',
        addRoleMon: 'Добави роля MON',
        removeRoleMon: 'Премахни роля MON',
        addRoleMgr: 'Добави роля MGR',
        removeRoleMgr: 'Премахни роля MGR',
        restartMon: 'Рестартирай услугата MON',
        restartMgr: 'Рестартирай услугата MGR',
        addMon: 'Добави MON',
        removeMon: 'Премахни MON',
        removeMonFrom: 'Премахни ролята MON от {node}',
        addMgr: 'Добави MGR',
        removeMgr: 'Премахни MGR',
        removeMgrFrom: 'Премахни ролята MGR от {node}',
        addMds: 'Добави MDS',
        removeMds: 'Премахни MDS',
        removeMdsFrom: 'Премахни ролята MDS от {node}',
        mdsSection: 'Сървъри за метаданни (MDS)',
        noMds: 'Няма декларирани MDS — файловата система първо се нуждае от един',
        mdsHint: 'Членството на MDS е собствено от първия ден: клъстер без CephFS не декларира нито един, един активен плюс един standby обслужват добре една файлова система. Ceph избира активните и standby измежду декларираните демони.',
        mdsActiveFor: 'активен — {fs}',
        mdsNotObserved: 'още не е наблюдаван',
        lastMdsGuard: 'Последният MDS не може да се премахне, докато съществува файлова система — премахнете първо файловите системи',
        lastMonGuard: 'Последният MON не може да се премахне — унищожаването на клъстера е единственият изход',
        lastMgrGuard: 'Последният MGR не може да се премахне — управляван клъстер никога не върви без мениджър',
        registerDevice: 'Добави OSD',
        unregisterDevice: 'Дерегистрирай',
        activeDeviceGuard: 'Активен OSD — излиза през жизнения цикъл на OSD, не от регистъра',
        colNode: 'Възел',
        devicePhase: { registered: 'Регистрирано', active: 'Активно' },
        health: 'Здраве',
        state: 'Състояние',
        fsid: 'fsid',
        fsidPending: 'липсва — повторете бутстрапа',
        version: 'Версия на Ceph',
        publicNetwork: 'Публична мрежа',
        clusterNetwork: 'Клъстерна мрежа',
        clusterNetworkCollapsed: '= public',
        noActions: 'Няма налични действия в тази фаза',
        destroyedNote: 'Клъстерът е унищожен — редът скоро ще се премахне автоматично'
      },
      overview: {
        services: 'Услуги',
        ok: 'в изправност',
        warning: 'предупреждение',
        down: 'недостъпно',
        pgTitle: 'Състояния на PG',
        pgTotal: 'общо {n} PG',
        capacityTitle: 'Пространство',
        ioTitle: 'Текущ I/O',
        ioReadBw: 'Пропускателност при четене',
        ioWriteBw: 'Пропускателност при запис',
        ioReadIops: 'IOPS при четене',
        ioWriteIops: 'IOPS при запис',
        notObserved: 'още не е наблюдавано'
      },
      osd: {
        colId: 'ID',
        colClass: 'Клас на устройството',
        colState: 'Състояние',
        colSize: 'Размер',
        colPgs: 'PG',
        empty: 'Няма нито един OSD — добавете един от деклариран диск за данни',
        markIn: 'Маркирай IN',
        markOut: 'Маркирай OUT',
        scrub: 'Изпълни scrub',
        deepScrub: 'Изпълни дълбок scrub',
        restart: 'Рестартирай услугата',
        details: 'Детайли',
        actionGuard: 'Само върху активен OSD на разгърнат клъстер',
        inTitle: 'Маркирай OSD IN',
        inBody: 'osd.{id} се връща в разпределението на данните (ceph osd in): Ceph ребалансира данни върху него.',
        outTitle: 'Маркирай OSD OUT',
        outBody: 'osd.{id} излиза от разпределението на данните (ceph osd out): данните му се ребалансират другаде и редундантността е НАМАЛЕНА, докато тече backfill. Обратимо във всеки момент с „Маркирай IN“.',
        scrubTitle: 'Планирай scrub',
        scrubBody: 'Планира се scrub на osd.{id}: MON го нарежда на опашка, а състоянията на PG в следващите обхождания разказват изхода.',
        deepScrubTitle: 'Планирай дълбок scrub',
        deepScrubBody: 'Планира се дълбок scrub на osd.{id}: вариантът, който проверява байтовете — по-тежък за I/O, същата механика.',
        restartTitle: 'Рестартирай услугата OSD',
        restartBody: 'osd.{id} се спира и рестартира под надзора на уъркъра на своя възел.',
        started: 'Действието е стартирано — наблюдението се обновява само',
        error: 'Действието върху OSD беше отказано'
      },
      osdDetail: {
        title: 'Детайли за OSD',
        tabGeneral: 'Общи',
        tabNetwork: 'Мрежа',
        tabDevices: 'Устройства',
        version: 'Версия',
        hostname: 'Име на хоста',
        dataPath: 'Път към данните на OSD',
        objectStore: 'Object store на OSD',
        encrypted: 'Шифрован',
        yes: 'Да',
        no: 'Не',
        memory: 'Използвана памет (PSS)',
        pid: 'Идентификатор на процеса (PID)',
        front: 'Front адрес (клиенти и монитори)',
        hbFront: 'Front адрес за пулс',
        back: 'Back адрес (OSD)',
        hbBack: 'Back адрес за пулс',
        colDevice: 'Устройство',
        colType: 'Тип',
        colPhysical: 'Физическо устройство',
        colSize: 'Размер',
        volumeTitle: 'Детайли за тома',
        creationTime: 'Дата на създаване',
        lvName: 'LV Name',
        lvPath: 'LV Path',
        lvUuid: 'LV UUID',
        vgName: 'VG Name',
        noDevices: 'Няма наблюдавани устройства за този OSD'
      },
      restart: {
        title: 'Рестартирай услугата',
        monBody: 'Демонът MON на {node} се спира и рестартира под надзора на уъркъра.',
        mgrBody: 'Демонът MGR на {node} се спира и рестартира под надзора на уъркъра.',
        started: 'Рестартът е стартиран — наблюдението се обновява само',
        error: 'Рестартът беше отказан'
      },
      encryptionMode: {
        alwaysOn: 'Винаги включено (dmcrypt)',
        alwaysOff: 'Винаги изключено',
        perOsd: 'Избор за всеки OSD',
        section: 'Шифроване на OSD в покой',
        title: 'Смени режима на шифроване на OSD',
        hint: 'Как се подготвят НОВИТЕ OSD. Съществуващите OSD пазят своето състояние по диск: за да го смените, OSD се премахва и се създава наново.',
        body: 'Режимът става "{mode}" и важи САМО за НОВИТЕ OSD: всеки съществуващ OSD пази текущото си състояние на шифроване.',
        apply: 'Смени режима',
        error: 'Смяната на режима беше отказана'
      },
      pin: {
        address: 'Публичен адрес (незадължителен пин)',
        clusterAddress: 'Клъстерен адрес (незадължителен пин)',
        autoPlaceholder: 'автоматично в подмрежата {cidr}',
        hint: 'Адресиране за всеки демон: празно = Ceph се закача сам вътре в декларираната мрежа; попълнено = този екземпляр се пинва към адреса в своята секция от конфигурацията.'
      },
      addMon: {
        title: 'Добави възел',
        node: 'Възел',
        address: 'Публичен адрес',
        addressHint: 'Адресите на възела, които IPAM познава в публичната подмрежа — автоматично, когато съществуваща декларация покрива възела.',
        clusterAddress: 'Клъстерен адрес',
        clusterAddressHint: 'Задължително: клъстерната подмрежа е отделна и възелът още не е деклариран в нея.',
        noAddresses: 'IPAM не познава адреси на този възел в подмрежата',
        error: 'Добавянето на MON беше отказано'
      },
      removeMon: {
        title: 'Премахни MON',
        body: 'MON и неговият колокиран MGR напускат възела {node}. На разгърнат клъстер демоните се спират и се премахват от кворума.',
        error: 'Премахването на MON беше отказано'
      },
      addMgr: {
        title: 'Добави MGR',
        node: 'Възел',
        hint: 'Разширени (разделени MON/MGR): самостоятелен мениджър се ражда на избрания възел член чрез задача, привързана към възела. Изборът active/standby на Ceph сам определя активния MGR.',
        error: 'Добавянето на MGR беше отказано'
      },
      removeMgr: {
        title: 'Премахни MGR',
        body: 'Самостоятелният MGR напуска възела {node}. На разгърнат клъстер демонът се спира и състоянието му се премахва; MON на възела (ако има такъв) не се докосва.',
        error: 'Премахването на MGR беше отказано'
      },
      addMds: {
        title: 'Добави MDS',
        node: 'Възел',
        hint: 'Сървърът за метаданни на CephFS: ражда се на избрания възел член чрез задача, привързана към възела, под надзора на уъркъра като MON и MGR. Ceph сам избира активни и standby — един активен плюс един standby обслужват добре една файлова система.',
        error: 'Добавянето на MDS беше отказано'
      },
      removeMds: {
        title: 'Премахни MDS',
        body: 'MDS напуска възела {node}. На разгърнат клъстер демонът се спира и състоянието му се премахва; API отказва последния MDS, докато файлова система има нужда от него.',
        error: 'Премахването на MDS беше отказано'
      },
      split: {
        title: 'Разделени MON/MGR',
        label: 'Позволи MON и MGR на разделени възли',
        hint: 'Изключено (по подразбиране) = ратифицираният стандарт: по един MGR върви колокиран с всеки MON, едно-единствено членство. Включено = членството на MGR става собствено, управлявано с действията „Добави/Премахни MGR“ в раздела с възлите за управление.',
        enable: 'Включи',
        disable: 'Изключи',
        enableBody: 'Членството на MGR става независимо от MON, инициализирано от текущата колокация. Действията „Добави/Премахни MGR“ се появяват в раздела с възлите за управление. Това разхлабва платформеното подразбиране — дръжте го само ако знаете защо ви трябва.',
        disableBody: 'Връщане към стандартната колокация: по един MGR с всеки MON, едно-единствено членство. Допустимо само ако членството на MGR вече съвпада с MON — подравнете го първо с „Добави/Премахни MGR“, иначе API ще откаже.',
        error: 'Промяната беше отказана'
      },
      rawEditor: {
        title: 'Суров CRUSH редактор',
        label: 'Показвай суровия редактор на crushmap в раздела CRUSH',
        hint: 'Изключено (по подразбиране) = направляваната повърхност на правилата е стандартният инструмент. Включено = разделът CRUSH показва и декомпилираната crushmap като редактируем текст. Запазването винаги изисква sudo, името на клъстера като потвърждение и минава през compile + test на crushtool, ПРЕДИ да достигне клъстера.'
      },
      osdFlags: {
        section: 'Глобални OSD флагове',
        title: 'Предефиниране на OSD флаговете',
        notObserved: 'още не са наблюдавани',
        standardFlowsHint: 'Стандартните потоци на платформата управляват тези флагове сами в обичайните случаи (поддръжката на възел поставя прицелен noout, смяната на диск минава през жизнения цикъл на OSD). Тази секция е ръчното предефиниране за оператора, който знае какво прави.',
        notDeployedGuard: 'OSD флаговете съществуват само на разгърнат клъстер',
        set: 'Постави флаг',
        unset: 'Премахни флаг',
        setBody: 'Глобалният флаг {flag} ще бъде ПОСТАВЕН върху osdmap. Остава, докато не бъде премахнат изрично — забравен флаг деградира самовъзстановяването на клъстера.',
        unsetBody: 'Глобалният флаг {flag} ще бъде ПРЕМАХНАТ от osdmap.',
        error: 'Промяната на флага беше отказана',
        flag: {
          noout: 'Никой OSD не се маркира като out от разпределението на данните — никакво ребалансиране при загуба на демон',
          norebalance: 'Ребалансирането на данните е преустановено',
          nobackfill: 'Backfill е преустановен',
          norecover: 'Recovery е преустановено',
          pause: 'ЦЕЛИЯТ клиентски I/O е в пауза (четения и записи)',
          noin: 'Стартиращите се OSD не се маркират като in автоматично',
          nodown: 'Недостъпните OSD не се маркират като down — маскира реални повреди'
        }
      },
      pools: {
        section: 'Пулове',
        create: 'Създай пул',
        createGuard: 'Пуловете съществуват само на разгърнат клъстер',
        notObserved: 'Няма наблюдения на пуловете — обхождането на MON докладва тук',
        empty: 'Няма пулове на клъстера',
        colName: 'Име',
        colReplication: 'Size / min size',
        colPgNum: 'PG',
        colApplication: 'Приложение',
        colRule: 'CRUSH правило',
        colUsage: 'Използване',
        observedAtLabel: 'Наблюдаван на',
        objects: '{n} обекта',
        inUseBy: 'използва се от {name}',
        internalGuard: 'Вътрешен пул на Ceph — платформата никога не го изтрива',
        delete: 'Изтрий пул',
        deleteGuard: 'Консумиран от хранилището {name} — изтрийте първо хранилището',
        hint: 'Само реплицирани пулове (erasure coding извън обхвата на v1). Репликацията живее в Ceph: тази таблица е наблюдаваната истина от обхождането на MON.',
        createTitle: 'Създай пул',
        createHint: 'Пулът се ражда на клъстера с поисканата репликация и с включено приложение rbd — работата върши задача на MON възел. Включете „Предложи като хранилище“, за да го консумирате веднага със същия жест.',
        name: 'Име на пула',
        nameHint: 'DNS-безопасно (малки букви, цифри, тирета).',
        size: 'Реплики (size)',
        sizeHint: 'Копия на всеки обект. По подразбиране 3.',
        minSize: 'Минимални реплики (min_size)',
        minSizeHint: 'Минимум копия за обслужване на I/O — следва size − 1, докато не го промените.',
        createError: 'Създаването на пула беше отказано',
        deleteTitle: 'Изтрий пул',
        deleteBody: 'Пулът {pool} и ВСЕКИ обект в него се унищожават необратимо. Въведете името на пула за потвърждение.',
        confirmLabel: 'Име на пула',
        confirmHint: 'Въведете името на пула за потвърждение',
        deleteError: 'Изтриването на пула беше отказано',
        detailTitle: 'Детайли за пула',
        autoscaler: 'PG Autoscaler',
        autoscalerOn: 'Активен',
        autoscalerOff: 'Неактивен',
        autoscalerWarn: 'Известяване',
        pgNumLabel: 'Брой PG',
        pgNumCaption: 'Наблюдавано: автоматичното мащабиране може да го променя самостоятелно — това поле записва желание.',
        storage: 'Свързано TVirt хранилище',
        addAsStorage: 'Добави като TVirt хранилище',
        ruleSudoHint: 'Смяната на CRUSH правилото изисква операторската парола.',
        updateError: 'Промяната на пула беше отказана',
        updated: 'Промяната на пула е стартирана — наблюдението се обновява само'
      },
      crush: {
        section: 'CRUSH правила',
        notObserved: 'Още няма CRUSH наблюдения — обхождането на MON докладва тук',
        empty: 'Няма наблюдавани правила на клъстера',
        hint: 'Едно правило решава КЪДЕ отиват копията на всеки обект — неговият домейн на отказ е единицата, която може да откаже, без да се губят данни. Пуловете сочат към правило; вграденото replicated_rule (една реплика на сървър) е подразбирането при раждане.',
        create: 'Създай правило',
        createGuard: 'CRUSH правилата съществуват само на разгърнат клъстер',
        createTitle: 'Създай CRUSH правило',
        createHint: 'Правило = избор на домейн на отказ. Правилото се ражда реплицирано върху root по подразбиране — работата върши задача на MON възел; свържете пуловете после от раздела „Пулове“.',
        createError: 'Създаването на правилото беше отказано',
        name: 'Име на правилото',
        nameHint: 'DNS-безопасно (малки букви, цифри, тирета).',
        domain: 'Домейн на отказ',
        domainChoice: {
          osd: 'Всяка реплика на различен OSD',
          host: 'Всяка реплика на различен сървър',
          rack: 'Всяка реплика в различен rack'
        },
        domainCustom: 'Персонализирано (стъпки, написани на ръка)',
        domainOther: 'Всяка реплика в различен {type}',
        rackGuardHint: 'В наблюдаваната йерархия не съществува нито един rack bucket: правилото все пак може да се създаде, но никой пул няма да може да го сочи, докато rack не бъде деклариран в разположението на сървърите членове (настройки на възела) — задачата за подравняване изгражда bucket-а и свързването се отваря само.',
        treeTitle: 'Наблюдавана йерархия',
        treeNotObserved: 'Няма наблюдения на йерархията — обхождането на MON докладва тук',
        treeOsds: '{n} OSD',
        treeHint: 'CRUSH картата, както я вижда клъстерът: root → декларирани нива → сървъри (хостове) → OSD. Топологията следва декларираното разположение на всеки сървър (настройки на възела) — промяна на разположението я подравнява чрез задача.',
        unplacedWarning: 'Членове без декларирано разположение: {nodes} — техните хостове остават директно под root, извън декларираната топология. Декларирайте разположението в настройките на възела (предупреждение, никога блокировка).',
        colName: 'Име',
        colDomain: 'Домейн на отказ',
        colPools: 'Пулове',
        builtinChip: 'вградено',
        builtinGuard: 'Правилото по подразбиране на клъстера — платформата никога не го изтрива',
        detailAction: 'Детайли за правилото',
        detailType: 'Тип',
        backToRules: 'Правила',
        ruleNotObserved: 'Наблюдаваният списък с правила не назовава това правило',
        noPools: 'Никой пул не стъпва върху това правило',
        delete: 'Изтрий правило',
        deleteTitle: 'Изтрий CRUSH правило',
        deleteBody: 'Правилото {rule} се премахва от crushmap на клъстера. Никой пул не бива да стъпва върху него. Въведете името на правилото за потвърждение.',
        deleteGuard: 'Пулът {name} стъпва върху него — пренасочете първо пула',
        confirmLabel: 'Име на правилото',
        confirmHint: 'Въведете името на правилото за потвърждение',
        deleteError: 'Изтриването на правилото беше отказано',
        changeRule: 'Смени CRUSH правилото',
        changeRuleTitle: 'Смени CRUSH правилото',
        changeRuleHint: 'Пулът започва да разполага обектите си според избраното правило — Ceph мести съществуващите данни, за да се съобразят (на пълен пул следва ребалансиране).',
        changeRuleError: 'Смяната на правилото беше отказана',
        rule: 'CRUSH правило',
        rawTitle: 'Сурова crushmap (декомпилирана)',
        rawWarning: 'ОПАСНОСТ: този текст е ЦЯЛАТА политика на разположение на клъстера. Грешна карта може да счупи разположението на всички пулове наведнъж. Запазването компилира и изпитва картата с crushtool, ПРЕДИ да я инжектира — но и валидна карта пак може да е лоша идея.',
        rawReload: 'Презареди',
        rawLoading: 'Заявка в ход — задача само за четене декомпилира crushmap…',
        rawSave: 'Запази crushmap',
        rawSaveTitle: 'Инжектирай crushmap',
        rawSaveBody: 'Промененият текст замества crushmap на ЦЕЛИЯ клъстер след compile + test на crushtool. Въведете името на клъстера за потвърждение.',
        rawConfirmLabel: 'Име на клъстера',
        rawConfirmHint: 'Въведете {name} за потвърждение',
        rawError: 'Операцията върху crushmap се провали',
        rawHint: 'Текстът е във формата на crushtool -d. Грешките от компилация и тест се връщат дума по дума от crushtool — картата не достига клъстера, ако някой от двата контролни пункта се провали.'
      },
      objects: {
        poolsSection: 'Разглеждане на обекти',
        poolsHint: 'Изберете пул, за да изброите неговите RBD образи. Всяко дълбоко четене върви като задача само за четене на MON възел — не блокира (нито бива блокирано от) реалните операции.',
        deployedGuard: 'Заявките за обекти отговарят само на разгърнат клъстер',
        browse: 'Разгледай обектите',
        detailAction: 'Детайли за образа',
        backToPools: 'Пулове',
        backToImages: 'Образи',
        refresh: 'Обнови',
        loading: 'Заявка в ход — задача само за четене разпитва клъстера…',
        error: 'Заявката се провали',
        retry: 'Опитай отново',
        notRbd: 'Пул с приложение "{app}" — не съдържа RBD образи, няма какво да се разглежда тук',
        noImages: 'Няма RBD образи в този пул',
        colImage: 'Образ',
        colSize: 'Размер',
        colObjects: 'Обекти',
        colSnapshots: 'Снапшоти',
        imagesHint: 'Дисковете върху консумиращо rbd хранилище са образи с името на своя диск-id. Броят обекти е провизираното (размер / размер на обект) — реалното използване живее в детайлите за образа.',
        infoTitle: 'Образ',
        infoSize: 'Виртуален размер',
        infoObjects: 'Обекти (провизирани)',
        infoObjectSize: 'Размер на обект',
        infoPrefix: 'Префикс на обектите',
        infoFormat: 'Формат',
        infoFeatures: 'Възможности',
        usageTitle: 'Реално използване (rbd du)',
        usageOf: 'от {provisioned} GiB провизирани',
        usageHint: 'Thin по природа: само записаните обекти заемат байтове.',
        watchersTitle: 'Наблюдатели',
        noWatchers: 'Няма наблюдатели — в момента никой не държи този образ отворен',
        snapshotsTitle: 'RBD снапшоти',
        noSnapshots: 'Няма RBD снапшоти върху този образ',
        colSnapshot: 'Снапшот',
        colProtected: 'Защитен',
        colTimestamp: 'Създаден',
        protected: 'защитен',
        mappingTitle: 'Физическо картиране (OSD набор)',
        mappingSampled: 'Извадка от {sampled} обекта от общо {total} — честно резюме: при големи образи наборът се схожда към ВСИЧКИ OSD на пула (CRUSH разпределя обектите по целия пул).',
        mappingComplete: 'Всички обекти са картирани ({total} от {total}).',
        objectQueryTitle: 'Картирай единичен обект',
        objectName: 'Име на обекта',
        objectHint: 'Имената на RADOS обектите са във вид <префикс>.<16-hex индекс> — ceph osd map отговаря с PG и тройки OSD.',
        mapObject: 'Картирай',
        primary: 'първичен: osd.{osd}'
      },
      registerDevice: {
        title: 'Регистрирай OSD устройство',
        hint: 'На жив клъстер регистрацията и ПОДГОТВЯ устройството: то става BlueStore OSD чрез автоматична задача, привързана към възела (никога празна, ратифицирано 2026-07-24). Едно устройство принадлежи най-много на един Ceph клъстер в целия флот.',
        disk: 'Диск за данни',
        diskHint: 'Декларираните дискове за данни на възела — име и сериен номер',
        noDeclared: 'Няма декларирани дискове за данни на този възел — отбележете ги първо в локалните настройки на възела',
        serialHint: 'Серийният номер на устройството — пинът на идентичност',
        encrypted: 'Шифровай този OSD (dmcrypt)',
        encryptedHint: 'Изборът за всеки OSD (режимът на клъстера е „избор за всеки OSD“): замразява се върху този диск при регистрацията — последваща смяна на режима никога не го презаписва; това прави редовото действие „шифровай/дешифровай“.',
        error: 'Регистрацията беше отказана'
      },
      unregisterDevice: {
        title: 'Дерегистрирай устройство',
        body: 'Само регистър: {name} престава да бъде OSD кандидат на този клъстер. Байтовете му не се докосват.',
        error: 'Дерегистрацията беше отказана'
      },
      deploy: {
        action: 'Опитай разгръщането отново',
        title: 'Повтори бутстрапа',
        body: 'Първоначалният бутстрап тръгва отново от текущата конфигурация: MON-ите се стартират, всяко регистрирано устройство се подготвя и активира като BlueStore OSD. Операцията върви като макрозадача — фазата се обновява сама.',
        started: 'Бутстрапът е стартиран — продължава като макрозадача; фазата се обновява сама',
        error: 'Бутстрапът беше отказан'
      },
      propose: {
        action: 'Предложи като хранилище',
        title: 'Предложи като хранилище',
        hintPool: 'Съществуващият пул {name} става TVirt хранилище: cephx идентичност, ограничена до пула, влиза в хранилището за ключове и ceph-rbd хранилището се ражда готово. Предложението консумира пула — никога не създава такъв.',
        hintFs: 'Съществуващата файлова система {name} става TVirt хранилище: cephx идентичност, ограничена до файловата система, влиза в хранилището за ключове и cephfs хранилището се ражда готово и монтирано. Предложението консумира файловата система — никога не създава такава.',
        name: 'Име на хранилището',
        nameHint: 'DNS-1123, уникално в скоупа — cephx идентичността взима името си от него.',
        path: 'Път вътре във файловата система',
        pathHint: 'Абсолютен път вътре във файловата система, който хранилището монтира — / при съмнение.',
        alsoPropose: 'Предложи веднага като хранилище',
        alsoProposePoolHint: 'След създаването същият жест предлага новородения пул като ceph-rbd хранилище — две изрични извиквания, един-единствен диалог.',
        alsoProposeFsHint: 'След създаването същият жест предлага новородената файлова система като cephfs хранилище — две изрични извиквания, един-единствен диалог.',
        guard: 'Предложи като хранилище — само на клъстер в изправност',
        started: 'Предложението е прието — хранилището се материализира; ще го намерите под „Хранилище“',
        submit: 'Създай хранилище',
        error: 'Предложението беше отказано'
      },
      fs: {
        section: 'Файлови системи',
        create: 'Създай файлова система',
        createGuard: 'Файловите системи съществуват само на разгърнат клъстер',
        mdsFirstGuard: 'Добавете първо MDS — файлова система без сървър за метаданни се ражда неизползваема',
        notObserved: 'Няма наблюдения на файловите системи — обхождането на MON докладва тук',
        empty: 'Няма файлови системи на клъстера',
        colName: 'Име',
        colPools: 'Пулове',
        colMds: 'MDS',
        noActiveMds: 'няма активен MDS',
        delete: 'Премахни файлова система',
        deleteGuard: 'Консумирана от хранилището {name} — изтрийте първо хранилището',
        hint: 'Файловата система притежава своите пулове за данни и метаданни (cephfs.<име>.data / .meta): раждат се с нея и умират с нея — removeFs, никога ръчно изтриване на пул. Тази таблица е наблюдаваната истина от обхождането на MON.',
        createTitle: 'Създай файлова система',
        createHint: 'Файловата система се ражда на клъстера със своите два пула (приложение cephfs) и се обслужва от декларираните MDS — работата върши задача на MON възел. Включете „Предложи като хранилище“, за да я консумирате веднага със същия жест.',
        name: 'Име на файловата система',
        nameHint: 'DNS-безопасно (малки букви, цифри, тирета).',
        sizeHint: 'Реплики на ДВАТА раждащи се пула. По подразбиране 3.',
        createError: 'Създаването на файловата система беше отказано',
        deleteTitle: 'Премахни файлова система',
        deleteBody: 'Файловата система {fs} и ВСЕКИ файл в нея се унищожават необратимо — нейните пулове за данни и метаданни умират с нея. Въведете името на файловата система за потвърждение.',
        confirmLabel: 'Име на файловата система',
        confirmHint: 'Въведете името на файловата система за потвърждение',
        deleteError: 'Премахването на файловата система беше отказано'
      },
      destroy: {
        action: 'Унищожи',
        retryAction: 'Опитай унищожаването отново',
        retryGuard: 'Унищожаването вече тече — повторът важи за провалено унищожаване (иначе write lease-ът отказва)',
        title: 'Унищожи клъстера',
        body: 'Разгърнатата фабрика се демонтира: всеки демон на този клъстер спира, системното му състояние и ключовете в хранилището за ключове се освобождават. При успешно унищожаване клъстерът се премахва автоматично.',
        confirmLabel: 'Име на клъстера',
        confirmHint: 'Въведете името на клъстера за потвърждение',
        wipe: 'Заличи регистрираните устройства',
        wipeHint: 'Отметнато: подписите на всяко регистрирано устройство се заличават — данните върху тях са унищожени. Неотметнато: байтовете остават непокътнати и устройствата се връщат като регистрирани.',
        guard: 'Унищожи — нищо не е разгърнато',
        started: 'Унищожаването е стартирано — продължава като макрозадача; фазата се обновява сама',
        error: 'Унищожаването беше отказано'
      },
      delete: {
        guard: 'Изтрий — само неразгърната конфигурация (първо унищожете)',
        title: 'Да се изтрие ли {name}?',
        body: 'Конфигурацията и нейният регистър на устройства се премахват. Допустимо само докато нищо не е разгърнато.',
        error: 'Изтриването беше отказано'
      }
    }
  }
}
